import * as React from 'react'

import SpinnerWrapper from '@frontrow/console/src/components/common/spinner-wrapper'
import PiggyStore from '@frontrow/console/src/components/pages/piggy-store-page/piggy-store'
import {usePiggyStore} from '@frontrow/console/src/hooks/api'

export function PiggyStoreContainer(): React.ReactElement {
  const {data, isLoading, error} = usePiggyStore()

  const errorMessage = error?.message || error

  return (
    <SpinnerWrapper isLoading={isLoading}>
      <PiggyStore items={data?.itemsData || []} error={errorMessage} />
    </SpinnerWrapper>
  )
}
